import { Button, Field, Text } from "components/commons";
import { InputAmount } from "components/field";
import { DipstickInputV2 } from "modules/shift-records/shift-records-details/shift-details-stock-inventory-dipstick-input";
import styles from "../delivery-log.module.scss";
import { DeleteOutline } from "@material-ui/icons";
import Big from "big.js";
import { stringToDecimal } from "utils/text.utils";
import { prettifyProductCode } from "utils/pretty.utils";
import { formatVolume } from "utils";

export const setVariance = ({
  quantityBeforeReceivingNumber = 0,
  quantityDeliveredNumber = 0,
  quantityAfterReceivingNumber = 0,
}) => {
  quantityBeforeReceivingNumber = stringToDecimal(quantityBeforeReceivingNumber || 0);
  quantityDeliveredNumber = stringToDecimal(quantityDeliveredNumber || 0);
  quantityAfterReceivingNumber = stringToDecimal(quantityAfterReceivingNumber || 0);

  return Big(quantityAfterReceivingNumber)
    .minus(Big(quantityBeforeReceivingNumber).add(quantityDeliveredNumber))
    .toNumber();
};

export const getQuantityAfterReceiving = (quantityBeforeReceiving, quantityDelivered) => {
  quantityBeforeReceiving = stringToDecimal(quantityBeforeReceiving || 0);
  quantityDelivered = stringToDecimal(quantityDelivered || 0);

  return Big(quantityBeforeReceiving).plus(quantityDelivered);
};

export const mapDataToListFuel = ({
  products,
  productsOptions = [],
  modifyField,
  modifyForm,
  onRemove,
  fieldsAsRows,
}) => {
  // const sku = fieldsAsRows[products.id].sku;
  const product = fieldsAsRows[products.id].product;
  const quantityBeforeReceivingMm = fieldsAsRows[products.id].quantityBeforeReceivingMm;
  const quantityBeforeReceivingLiter = fieldsAsRows[products.id].quantityBeforeReceivingLiter;
  const quantityDelivered = fieldsAsRows[products.id].quantityDelivered;
  const quantityAfterReceivingMm = fieldsAsRows[products.id].quantityAfterReceivingMm;
  const quantityAfterReceivingLiter = fieldsAsRows[products.id].quantityAfterReceivingLiter;

  return {
    product: <div style={{ marginTop: "2em" }}>{product?.value}</div>,
    quantityBeforeReceiving: (
      <div className={styles.inputRow}>
        <DipstickInputV2
          fields={quantityBeforeReceivingMm}
          unit={"mm"}
          placeholder={"0"}
          modifyField={modifyField}
          className={styles.dipstick}
          classNameInput={styles.dipstickTextField}
          classNameMessage={styles.lastItem}
        />
        <div
          style={{
            paddingTop: "10px",
          }}
        >
          /
        </div>
        <DipstickInputV2
          fields={quantityBeforeReceivingLiter}
          unit={"L"}
          placeholder={"0"}
          decimalPlaces={3}
          modifyField={modifyField}
          className={styles.dipstick}
          classNameInput={styles.dipstickTextField}
          classNameMessage={styles.lastItem}
        />
      </div>
    ),
    quantityDelivered: (
      <DipstickInputV2
        fields={quantityDelivered}
        unit={"L"}
        decimalPlaces={3}
        placeholder={"0"}
        modifyField={modifyField}
        className={styles.dipstick}
        classNameInput={styles.dipstickTextField}
        classNameMessage={styles.lastItem}
      />
    ),
    quantityAfterReceiving: (
      <div className={styles.inputRow}>
        <DipstickInputV2
          fields={quantityAfterReceivingMm}
          unit={"mm"}
          placeholder={"0"}
          modifyField={modifyField}
          className={styles.dipstick}
          classNameInput={styles.dipstickTextField}
          classNameMessage={styles.lastItem}
        />{" "}
        <div
          style={{
            paddingTop: "10px",
          }}
        >
          /
        </div>
        <DipstickInputV2
          fields={quantityAfterReceivingLiter}
          unit={"L"}
          decimalPlaces={3}
          placeholder={"0"}
          modifyField={modifyField}
          className={styles.dipstick}
          classNameInput={styles.dipstickTextField}
          classNameMessage={styles.lastItem}
        />
      </div>
    ),
    actions: <DeleteOutline style={{ color: "#5349b7" }} onClick={() => onRemove?.(products.id)} />,
  };
};

export const mapDataToListViewFuel = ({ products, allProducts = [] }) => {
  const product = products?.product;
  const quantityBeforeReceivingMm = products.quantityBeforeReceivingCm;
  const quantityBeforeReceivingLiter = products.quantityBeforeReceivingL;
  const quantityDelivered = products.quantityDeliveredL;
  const quantityAfterReceivingMm = products.quantityAfterReceivingCm;
  const quantityAfterReceivingLiter = products.quantityAfterReceivingL;

  return {
    product: <div style={{ margin: "10px 0px" }}>{prettifyProductCode(product)}</div>,
    quantityBeforeReceiving: (
      <div className={styles.inputRow}>
        {formatVolume(quantityBeforeReceivingMm, "mm", 4)} /{" "}
        {formatVolume(quantityBeforeReceivingLiter)}
      </div>
    ),
    quantityDelivered: formatVolume(quantityDelivered),
    quantityAfterReceiving: (
      <div className={styles.inputRow}>
        {formatVolume(quantityAfterReceivingMm, "mm", 4)} /{" "}
        {formatVolume(quantityAfterReceivingLiter)}
      </div>
    ),
  };
};

export const mapDataToListNonFuel = ({
  products,
  onRemove,
  fieldsAsRows,
  modifyField,
  modifyForm,
}) => {
  const sku = fieldsAsRows[products.id].sku;
  const product = fieldsAsRows[products.id].product;
  const variant = fieldsAsRows[products.id].variant;
  const category = fieldsAsRows[products.id].category;
  const quantityBeforeReceiving = fieldsAsRows[products.id].quantityBeforeReceiving;
  const quantityDelivered = fieldsAsRows[products.id].quantityDelivered;
  const quantityAfterReceiving = fieldsAsRows[products.id].quantityAfterReceiving;
  const variance = fieldsAsRows[products.id].variance;

  return {
    sku: <Text color="black">{sku?.value}</Text>,
    product: <Text color="black">{product?.value}</Text>,
    variant: <Text color="black">{variant?.value}</Text>,
    category: <Text color="black">{category?.value}</Text>,
    quantityBeforeReceiving: (
      <InputAmount
        {...quantityBeforeReceiving}
        placeholder={"0"}
        onChange={(name, props) => {
          modifyForm({
            [name]: props,
            [quantityAfterReceiving.name]: {
              value: getQuantityAfterReceiving(props?.value, quantityDelivered?.value),
            },
            [variance.name]: {
              value: setVariance({
                quantityBeforeReceivingNumber: props?.value,
                quantityDeliveredNumber: quantityDelivered?.value,
                quantityAfterReceivingNumber: getQuantityAfterReceiving(
                  props?.value,
                  quantityDelivered?.value,
                ),
              }),
            },
          });
        }}
      />
    ),
    quantityDelivered: (
      <InputAmount
        {...quantityDelivered}
        placeholder={"0"}
        onChange={(name, props) => {
          modifyForm({
            [name]: props,
            [quantityAfterReceiving.name]: {
              value: getQuantityAfterReceiving(quantityBeforeReceiving?.value, props?.value),
            },
            [variance.name]: {
              value: setVariance({
                quantityBeforeReceivingNumber: quantityBeforeReceiving.value,
                quantityDeliveredNumber: props.value,
                quantityAfterReceivingNumber: getQuantityAfterReceiving(
                  quantityBeforeReceiving?.value,
                  props.value,
                ),
              }),
            },
          });
        }}
      />
    ),
    quantityAfterReceiving: (
      <Field {...quantityAfterReceiving}>
        <InputAmount
          {...quantityAfterReceiving}
          placeholder={"0"}
          onChange={(name, props) =>
            modifyForm({
              [name]: props,
              [variance.name]: {
                value: setVariance({
                  quantityBeforeReceivingNumber: quantityBeforeReceiving.value,
                  quantityDeliveredNumber: quantityDelivered.value,
                  quantityAfterReceivingNumber: props.value,
                }),
              },
            })
          }
        />
      </Field>
    ),
    variance: (
      <Text color={variance?.value >= 0 ? "black" : "red"}>
        {variance?.value ? variance?.value?.toLocaleString() : 0}
      </Text>
    ),
    actions: (
      <Button link onClick={() => onRemove?.(products.id)}>
        <DeleteOutline style={{ color: "#5349b7" }} />
      </Button>
    ),
  };
};

export const mapDataToListViewNonFuel = ({ products, allProducts = [] }) => {
  const prod = allProducts?.find((p) => p.sku === products.product);
  const sku = products.product;
  const product = prod?.name;
  const variant = prod?.variant;
  const category = prod?.category?.name;
  const quantityBeforeReceiving = products.quantityBeforeReceiving;
  const quantityDelivered = products.quantityDelivered;
  const quantityAfterReceiving = products.quantityAfterReceiving;

  const variance = setVariance({
    quantityBeforeReceivingNumber: quantityBeforeReceiving,
    quantityDeliveredNumber: quantityDelivered,
    quantityAfterReceivingNumber: quantityAfterReceiving,
  });

  return {
    sku: <Text color="black">{sku}</Text>,
    product: <Text color="black">{product}</Text>,
    variant: <Text color="black">{variant}</Text>,
    category: <Text color="black">{category}</Text>,
    quantityBeforeReceiving: quantityBeforeReceiving,
    quantityDelivered: quantityDelivered,
    quantityAfterReceiving: quantityAfterReceiving,
    variance: <Text color={variance >= 0 ? "black" : "red"}>{variance || 0}</Text>,
  };
};
